
export function getPerc(number) {
    return Intl.NumberFormat('default', {
        style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 1,
    }).format(number);
}


export function getNbEtage(hauteurBat, annee) {
    let h = 2.5;
    if (annee < 1920) {
        h = 3.3;
    } else if (annee < 1948) {
        h = 3;
    } else if (annee < 1978) {
        h = 2.8;
    } else if (annee < 1983) {
        h = 2.6;
    } else {
        h = 2.5;
    }
    return Math.floor(hauteurBat / h);
}

export function removeCommas(strData, strDelimiter) {
    let tmp = strData.split(",", -1);
    let res = [];
    let buffer = "";
    tmp.forEach((t, i) => {
        let buffT = buffer + t;
        let test = buffT.split("\"");
        if (test.length % 2 === 1) {
            res.push(buffT.replaceAll("\"", ""));
            buffer = "";
        } else {
            buffer = buffT;
        }

    })
    return res;
}